<div
  [formGroup]="formGroup"
  *transloco="let t; read 'prices.upsert_price';">

  <div class="flex gap-10 mb-4">
    <div>
      <div class="text-2xl font-bold">
        {{ t('pricing_list') }}
      </div>
      <div class="text-sm">
        ({{ t('at_least_one') }})
      </div>
    </div>

    <psc-button
      size="small"
      type="secondary-yellow"
      (buttonClicked)="addPricing()">
      <div class="flex gap-2 items-center justify-center">
        {{ t('add_new_pricing') }}
        <mat-icon>add</mat-icon>
      </div>
    </psc-button>
  </div>

  <!--  Pricing list  -->
  <div formArrayName="pricingList" class="flex flex-col gap-8 items-center">
    <div class="border border-blue1 rounded p-4 w-fit" *ngFor="let price of pricingList.controls; let i = index"
         [formGroupName]="i"
         @inOutAnimation>
      <div class="flex gap-10 relative">
        <div class="flex-1">
          <div class="text-xl font-bold mb-2">
            {{ t('date_from') }}
          </div>
          <psc-price-date-picker
            [dateForm]="dateFrom(i)"></psc-price-date-picker>
        </div>
        <div class="relative hidden md:block">
          <div class="absolute bottom-[30px] text-4xl font-bold ">
            -
          </div>
        </div>
        <div class="flex-1">
          <div class="text-xl font-bold mb-2">
            {{ t('date_to') }}
          </div>
          <psc-price-date-picker
            [dateForm]="dateTo(i)"></psc-price-date-picker>
        </div>
        <div class="absolute top-0.5 right-0.5">
          <psc-button
            type="secondary-magenta"
            [label]="t('remove_pricing')"
            size="tiny"
            (buttonClicked)="removePricing(i)"></psc-button>
        </div>
      </div>

      <!--  Timeslots list  -->
      <h3 class="py-4">{{ t('times') }}:</h3>
      <div formArrayName="timeSlots">
        <ng-container *ngFor="let timeSlot of timeSlots(i).controls; let j = index" [formGroupName]="j">
          <div
            [ngClass]="{'border-sun-yellow border-t': j > 0}"
            class="flex flex-col md:flex-row md:border-none relative gap-5 py-5 md:py-1"
            @inOutAnimation>
            <div class="grid grid-cols-2 gap-3 items-end">
              <psc-select
                [options]="timeOptions"
                formControlName="timeFrom"
                [label]="t('timeFrom')"></psc-select>
              <psc-select
                [options]="timeOptions"
                formControlName="timeTo"
                [label]="t('timeTo')"></psc-select>
            </div>

            <div class="md:border w-[1px] h-[75px] after:content-[''] hidden md:block self-center"></div>

            <div class="grid grid-cols-5 gap-3 items-end">
              <psc-input
                formControlName="priceKWH"
                type="number"
                [label]="t('priceKWH')"></psc-input>
              <psc-input
                formControlName="priceDistribution"
                type="number"
                [label]="t('priceDistribution')"></psc-input>
              <psc-input
                formControlName="priceTransfer"
                type="number"
                [label]="t('priceTransfer')"></psc-input>
              <psc-input
                formControlName="pricePerPeakPower"
                type="number"
                [label]="t('pricePerPeakPower')"></psc-input>
              <psc-input
                formControlName="priceOIE"
                type="number"
                [label]="t('priceOIE')"></psc-input>
            </div>

            <div
              class="cursor-pointer hover:opacity-80 absolute md:relative top-5 md:top-auto right-5 md:right-auto self-center"
                 [ngClass]="{'invisible pointer-events-none': j === 0}"
              (click)="removeTimeslot(i, j)">
              <mat-icon class="text-magenta">delete</mat-icon>
            </div>

          </div>
        </ng-container>
      </div>

      <div class="flex justify-end">
        <psc-button
          size="small"
          type="secondary-blue"
          (buttonClicked)="addTimeSlot(i)">
          <div class="flex gap-2 items-center justify-center">
            {{ t('add_new') }}
            <mat-icon>add</mat-icon>
          </div>
        </psc-button>
      </div>
    </div>
  </div>

</div>
